import usersJson from '../../assets/users.json';

export const userInitState = {
  search: '',
  data: usersJson,
  isModalOpen: false,
};
